import { Loader2, X } from 'lucide-react';
import React from 'react';
import { Button } from '../common';

export interface PrintReceiptConfirmationModalProps {
  isOpen: boolean;
  billNumber?: number;
  isPrinting: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export const PrintReceiptConfirmationModal: React.FC<
  PrintReceiptConfirmationModalProps
> = ({ isOpen, billNumber, isPrinting, onConfirm, onCancel }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div
        className="absolute inset-0 bg-black/45 backdrop-blur-[1px]"
        onClick={isPrinting ? undefined : onCancel}
        onKeyDown={(event) => {
          if (event.key === 'Escape' && !isPrinting) onCancel();
        }}
        role="button"
        tabIndex={0}
        aria-label="Close print receipt confirmation"
      />

      <div className="relative mx-4 w-full max-w-lg overflow-hidden rounded-md bg-white text-black shadow-2xl">
        <div className="flex items-center justify-end px-4 pt-3">
          <button
            type="button"
            onClick={onCancel}
            disabled={isPrinting}
            className="rounded p-1 text-gray-500 transition-colors hover:bg-gray-100 hover:text-gray-700 disabled:opacity-60"
            aria-label="Close modal"
          >
            <X size={22} />
          </button>
        </div>

        <div className="px-8 pb-7 pt-1">
          {billNumber ? (
            <p className="text-center text-base font-semibold uppercase tracking-wide text-gray-900">
              Bill #{billNumber}
            </p>
          ) : null}
          <p className="mt-2 text-center text-base font-semibold text-gray-900">
            Print a receipt for this settlement?
          </p>

          <div className="mt-8 grid grid-cols-2 gap-2.5">
            <Button
              type="button"
              onClick={onConfirm}
              disabled={isPrinting}
              className="h-10 bg-emerald-500 text-xs font-semibold uppercase tracking-wide text-white hover:bg-emerald-600"
            >
              {isPrinting ? (
                <>
                  <Loader2 size={16} className="animate-spin" />
                  Printing
                </>
              ) : (
                'Yes'
              )}
            </Button>

            <Button
              type="button"
              onClick={onCancel}
              disabled={isPrinting}
              className="h-10 bg-rose-500 text-xs font-semibold uppercase tracking-wide text-white hover:bg-rose-600"
            >
              No
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
